export default __webpack_public_path__ + "static/media/Golden Glow bridal Kit  2.41799818.jpg";